import type { OperationsLensKey } from "@/api/endpoints";
import { InfoTooltip } from "@/components/InfoTooltip";
import { LENS_LABEL, LENS_TIP } from "../operationsLabels";

interface Props {
  value: OperationsLensKey | undefined;
  onChange: (next: OperationsLensKey | undefined) => void;
}

const KEYS: OperationsLensKey[] = ["stuck", "blocked", "stuckAndBlocked", "clear"];

/** All / Stuck / Blocked / Stuck + Blocked / Clear: looks at the open work through one attention state (a page mode, not a filter). */
export function LensControl({ value, onChange }: Props) {
  return (
    <div className="ops-ctl ops-ctl-lens">
      <label>
        Attention lens
        <InfoTooltip inline text={LENS_TIP} />
      </label>
      <div className="unit-toggle ops-lens" role="tablist" aria-label="Attention lens">
        <button type="button" role="tab" aria-selected={!value} className={!value ? "on" : ""} onClick={() => onChange(undefined)}>
          All
        </button>
        {KEYS.map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={value === key}
            className={`lens-${key}${value === key ? " on" : ""}`}
            onClick={() => onChange(value === key ? undefined : key)}
          >
            <i className="dot" aria-hidden="true" />
            {LENS_LABEL[key]}
          </button>
        ))}
      </div>
    </div>
  );
}
